"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCSSClassesToComponent = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
/**
 * For a given component, clone it and additional CSS classes to the newly created component.
 *
 * @param originalComponent The component to clone, and have new classes added to it
 * @param newClasses The classes to add to the given component
 */
var addCSSClassesToComponent = function (originalComponent, newClasses) {
    return react_1.default.cloneElement(originalComponent, {
        classes: classnames_1.default(originalComponent.props.classes, newClasses)
    });
};
exports.addCSSClassesToComponent = addCSSClassesToComponent;
